import React from "react";

import styles from "./Loader.module.css";

const Loader = (props) => (
  <div className={styles.loader}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Loader;
